<div class="form-field-wrapper">
  <div class="form-check form-switch">
      <input class="form-check-input" [formControl]="formControl" type="checkbox" role="switch" id="toggle{{label}}">
      <label class="form-field-label form-field-label__checkbox" for="toggle{{label}}">
        <app-input-helper-text [helpText]="helpText"></app-input-helper-text>
        {{label}}
      </label>
  </div>
</div>
